module.exports = __webpack_public_path__ + "assets/7c60bfd2024248cda6dcbb252992ea37.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/11/Drop_Bonus4.mp3
 ** module id = 209
 ** module chunks = 0
 **/